import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import NewsletterSection from "../Components/Landing/newsletter";
import Footer from "../Components/Footer/footer";
import KryzenHero from "../Components/Landing/hero";
import performRequest from "../Api/request";
import Pagination from "../Layouts/pagination";
import getFilteredURL from "../Functions/filters";


export default function BlogList() {
    const navigate = useNavigate();
    const [blogs, setBlogs] = useState([])
    const [showPage, setShowPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // const [refresh, setRefresh] = useState(false);
    const [page, setPage] = useState(1);
    // const [filters, setFilters] = useState({
    //   productName: "",
    // });




useEffect(()=>{
  
  performRequest("GET", getFilteredURL("/blog/get-blogs", page)).then((res)=>{
    setBlogs(res?.data?.blogs)
    setTotalPages(Math.ceil(res?.data?.totalBlogs / 27))
  }).catch((error)=>{
    console.log(error)
  })

},[page])

  return (
    <>
      <Helmet>
        <title>
          Kryzen Biotech | India's Leading Hydroponics & Agri-Tech Company |
          Kryzen Info
        </title>
        <meta
          name="description"
          content="Kryzen Biotech provides end-to-end hydroponic farm development, automation, AI-based farm management, and agri training across India."
        />

        {/* Keywords */}
        <meta
          name="keywords"
          content="hydroponics, hydroponic farming india, smart farming, agri tech, kryzen biotech, greenhouse, farm automation, hydroponic setup"
        />

        {/* Canonical */}
        <link rel="canonical" href="https://kryzen.com/" />

        {/* Open Graph for Social Share */}
        <meta
          property="og:title"
          content="Kryzen Biotech - Smart & Sustainable Farming"
        />
        <meta
          property="og:description"
          content="Leading hydroponics & agri-tech solutions in India."
        />
        <meta property="og:image" content="https://kryzen.com/og-image.jpg" />
        <meta property="og:url" content="https://kryzen.com" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="page-wrapper container">
        <KryzenHero
          title="Unveiling the Future of Smart & Sustainable Farming"
          subtitle="Kryzen Biotech brings you the latest updates in hydroponics, farm automation, AI-powered cultivation, commercial training, and modern agri-tech innovations shaping India’s sustainable farming landscape."
          buttonText="🌿 Join Newsletter"
          buttonLink="#newsletter"
          background="bg-light"
        />
        <div className="row ">
          <div className="col-12">
            <div className="max-w-3xl mx-auto ">
              <h2 className="mt-0 mb-4 display-6 fw-bold border border-0 border-secondary  text-white p-2 rounded-3 text-center reveal" style={{background:"limegreen"}} >
          Latest Articles
        </h2>

        <div className="row g-4">
  {blogs.map((post) => (
    <article
      key={post.id}
      className="col-12 col-md-6 col-lg-4 p-3"
    >
      <div className="p-4 rounded-lg shadow border h-100 d-flex flex-column">
        <h2 className="text-xl font-semibold mb-2">
          {post.title}
        </h2>

        <p className="text-gray-600 text-sm flex-grow">{post.excerpt}</p>

        <button
          onClick={() => navigate(`/news/${post.slug}`)}
          className="btn btn-outline-green mt-auto"
        >
          Read More
        </button>
      </div>
    </article>
  ))}


</div>

            </div>
          </div>
       
          <Pagination
                            page={page}
                            setPage={setPage}
                            totalPages={totalPages}
                            pageDatalength={blogs?.length}
                            showPage={showPage}
                            setShowPage={setShowPage}
                          />
        </div>
        {/* <LandingHero /> */}
        <hr className="border border-1 border-dark" />
        <NewsletterSection />
        <Footer />
      </div>
    </>
  );
}
